import React from 'react';
// import { Link } from 'react-router';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import 'react-toastify/dist/ReactToastify.css';
// import * as documentActions from '../../actions/documentUploadActions';
// import * as constant from '../../constants/constant';
import {
	Modal,
} from 'react-bootstrap';
const autoBind = require('auto-bind');
//login container component
class Signin extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			appointmentId: this.props.appointmentId,
			symptoms: this.props.symptoms,
		};
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps) {
	}

	render() {
		return (
			<Modal show={this.props.openModal} size="modal-sm" onHide={this.props.hideConditionModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideConditionModal} /> */}
					<div className="signIn">Symptoms</div>
				</Modal.Header>
				<Modal.Body>
					<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
						{this.state.symptoms ? this.state.symptoms : 'No Symptoms'}
					</div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		// appointmentDocument: state.uploadDocument.uploadedImages ? state.uploadDocument.uploadedImages : ''
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		// documentactions: bindActionCreators(documentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Signin);
